export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000" as const

/** Ghost rank for entities not in Top 100 */
export const GHOST_RANK = 101

export const BASE_CHAIN_ID = 8453
export const BASE_SEPOLIA_CHAIN_ID = 84532

export const USDC_ADDRESS = {
	[BASE_CHAIN_ID]: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913" as const,
	[BASE_SEPOLIA_CHAIN_ID]: "0xb825dF45fC373425d8a93017Aff70c1a4377db55" as const,
}

export const USDC_DECIMALS = 6

export const LMSR = {
	BINARY_BUCKET_COUNT: 2,
	INDEX_BUCKET_COUNT: 5,
	DEFAULT_B_TOP_10: 150,
	DEFAULT_B_11_TO_50: 75,
	MIN_BUCKET_COUNT: 2,
	MAX_BUCKET_COUNT: 20,
} as const

export const TRADING = {
	/** Minimum buy amount in USDC for UI enforcement */
	MIN_BUY_AMOUNT: 1,
	/** Minimum buy amount in raw USDC units (6 decimals) */
	MIN_BUY_AMOUNT_RAW: 1_000_000n,
} as const

export const TIMING = {
	WEEK_START_DAY: 5, // Friday
	WEEK_END_DAY: 4, // Thursday
	DISPUTE_WINDOW_SECONDS: 24 * 60 * 60,
	SNAPSHOT_RETRY_WINDOW_SECONDS: 6 * 60 * 60,
} as const

export const PRICE_DECIMALS = 18

/** Standard error codes used by backend (ConvexError) and frontend error handling */
export const ERROR_CODES = {
	// Authentication & Authorization
	UNAUTHENTICATED: "UNAUTHENTICATED",
	UNAUTHORIZED: "UNAUTHORIZED",
	FORBIDDEN: "FORBIDDEN",
	INVALID_CREDENTIALS: "INVALID_CREDENTIALS",

	// Resource errors
	NOT_FOUND: "NOT_FOUND",
	USER_NOT_FOUND: "USER_NOT_FOUND",
	UNKNOWN_MARKET: "UNKNOWN_MARKET",
	ALREADY_EXISTS: "ALREADY_EXISTS",
	CONFLICT: "CONFLICT",

	// Validation errors
	INVALID_ARGS: "INVALID_ARGS",
	VALIDATION_ERROR: "VALIDATION_ERROR",
	PRECONDITION_FAILED: "PRECONDITION_FAILED",

	// Business logic errors
	EMPTY_DATA: "EMPTY_DATA",
	PREPARATION_EXPIRED: "PREPARATION_EXPIRED",
	GASLESS_UNAVAILABLE: "GASLESS_UNAVAILABLE",
	RATE_LIMITED: "RATE_LIMITED",

	// External service errors
	EXTERNAL_ERROR: "EXTERNAL_ERROR",

	// Configuration errors
	UNSUPPORTED_CHAIN: "UNSUPPORTED_CHAIN",
	INTERNAL_ERROR: "INTERNAL_ERROR",
} as const

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES]

// =============================================================================
// Market Constants
// =============================================================================

/** Canonical outcome labels for binary markets (2 buckets) */
export const BINARY_OUTCOME_LABELS = ["Long", "Short"] as const

/** Fall from Grace market constants */
export const FFG = {
	/** Display name shown in UI */
	DISPLAY_NAME: "Fall from Grace",
	/** Market question/title */
	TITLE: "Falls most in CT mindshare next week?",
} as const

/** Binary market title template - use with template literal: `Will ${name} ${BINARY_TITLE_SUFFIX}` */
export const BINARY_TITLE_SUFFIX = "CT mindshare rise next week?" as const

/** Generate binary market title */
export function getBinaryMarketTitle(displayName: string): string {
	return `Will ${displayName} ${BINARY_TITLE_SUFFIX}`
}

// =============================================================================
// Utility Types
// =============================================================================

/**
 * Maybe type - represents a value that can be null or undefined
 * Use this for optional values that may not exist
 */
export type Maybe<T> = T | null | undefined
